// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/bidding_block_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { LicenseType } from "../../bfftypes/v1/license_type_pb";
import { file_bfftypes_v1_license_type } from "../../bfftypes/v1/license_type_pb";
import type { BiddingBlockApprovalRequest, BiddingBlockApprovalRequestListItem, BiddingBlockBidGroupType, BiddingBlockBidInput, BiddingBlockCsvRowResult, BlockBidWriteBlockedReason } from "./bidding_block_model_pb";
import { file_bffuser_v1_bidding_block_model } from "./bidding_block_model_pb";
import type { BiddingApprovalMode, BiddingBulkApprovalApproved, BiddingBulkApprovalFailureReason, BiddingBulkApprovalTarget, BiddingBulkWithdrawAccepted, BiddingBulkWithdrawFailure, BiddingBulkWithdrawTarget, BiddingLifecycleAction } from "./bidding_common_model_pb";
import { file_bffuser_v1_bidding_common_model } from "./bidding_common_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/bidding_block_service.proto.
 */
export const file_bffuser_v1_bidding_block_service: GenFile = /*@__PURE__*/
  fileDesc("CiZiZmZ1c2VyL3YxL2JpZGRpbmdfYmxvY2tfc2VydmljZS5wcm90bxIKYmZmdXNlci52MSJ0CidMaXN0QmlkZGluZ0Jsb2NrQXBwcm92YWxSZXF1ZXN0c1JlcXVlc3QSMgoSdGFyZ2V0X2RhdGVfZmlsdGVyGAEgASgLMhEuZ29vZ2xlLnR5cGUuRGF0ZUgAiAEBQhUKE190YXJnZXRfZGF0ZV9maWx0ZXIiagooTGlzdEJpZGRpbmdCbG9ja0FwcHJvdmFsUmVxdWVzdHNSZXNwb25zZRI+CgVpdGVtcxgBIAMoCzIvLmJmZnVzZXIudjEuQmlkZGluZ0Jsb2NrQXBwcm92YWxSZXF1ZXN0TGlzdEl0ZW0iPQolR2V0QmlkZGluZ0Jsb2NrQXBwcm92YWxSZXF1ZXN0UmVxdWVzdBIUCgJpZBgBIAEoCUIIukgFcgOwAQEiawomR2V0QmlkZGluZ0Jsb2NrQXBwcm92YWxSZXF1ZXN0UmVzcG9uc2USQQoQYXBwcm92YWxfcmVxdWVzdBgBIAEoCzInLmJmZnVzZXIudjEuQmlkZGluZ0Jsb2NrQXBwcm92YWxSZXF1ZXN0Is4DCihDcmVhdGVCaWRkaW5nQmxvY2tBcHByb3ZhbFJlcXVlc3RSZXF1ZXN0Ei4KC3RhcmdldF9kYXRlGAEgASgLMhEuZ29vZ2xlLnR5cGUuRGF0ZUIGukgDyAEBEkIKDWFwcHJvdmFsX21vZGUYAiABKA4yHy5iZmZ1c2VyLnYxLkJpZGRpbmdBcHByb3ZhbE1vZGVCCrpIB4IBBBABIAASRAoKZ3JvdXBfdHlwZRgDIAEoDjIkLmJmZnVzZXIudjEuQmlkZGluZ0Jsb2NrQmlkR3JvdXBUeXBlQgq6SAeCAQQQASAAEjkKB3ByaW1hcnkYBCABKAsyIC5iZmZ1c2VyLnYxLkJpZGRpbmdCbG9ja0JpZElucHV0Qga6SAPIAQESOAoJc2Vjb25kYXJ5GAUgASgLMiAuYmZmdXNlci52MS5CaWRkaW5nQmxvY2tCaWRJbnB1dEgAiAEBEjkKC2lzc3Vlcl90eXBlGAYgASgOMhguYmZmdHlwZXMudjEuTGljZW5zZVR5cGVCCrpIB4IBBBABIAASHgoHY2FzZV9pZBgHIAEoCUIIukgFcgOwAQFIAYgBAUIMCgpfc2Vjb25kYXJ5QgoKCF9jYXNlX2lkIm4KKUNyZWF0ZUJpZGRpbmdCbG9ja0FwcHJvdmFsUmVxdWVzdFJlc3BvbnNlEkEKEGFwcHJvdmFsX3JlcXVlc3QYASABKAsyJy5iZmZ1c2VyLnYxLkJpZGRpbmdCbG9ja0FwcHJvdmFsUmVxdWVzdCKvAwooVXBkYXRlQmlkZGluZ0Jsb2NrQXBwcm92YWxSZXF1ZXN0UmVxdWVzdBIUCgJpZBgBIAEoCUIIukgFcgOwAQESQgoNYXBwcm92YWxfbW9kZRgCIAEoDjIfLmJmZnVzZXIudjEuQmlkZGluZ0FwcHJvdmFsTW9kZUIKukgHggEEEAEgABI5CgdwcmltYXJ5GAMgASgLMiAuYmZmdXNlci52MS5CaWRkaW5nQmxvY2tCaWRJbnB1dEIGukgDyAEBEjgKCXNlY29uZGFyeRgFIAEoCzIgLmJmZnVzZXIudjEuQmlkZGluZ0Jsb2NrQmlkSW5wdXRIAIgBARI/ChNleHBlY3RlZF91cGRhdGVkX2F0GAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEIGukgDyAEBEjkKC2lzc3Vlcl90eXBlGAYgASgOMhguYmZmdHlwZXMudjEuTGljZW5zZVR5cGVCCrpIB4IBBBABIAASHgoHY2FzZV9pZBgHIAEoCUIIukgFcgOwAQFIAYgBAUIMCgpfc2Vjb25kYXJ5QgoKCF9jYXNlX2lkIm4KKVVwZGF0ZUJpZGRpbmdCbG9ja0FwcHJvdmFsUmVxdWVzdFJlc3BvbnNlEkEKEGFwcHJvdmFsX3JlcXVlc3QYASABKAsyJy5iZmZ1c2VyLnYxLkJpZGRpbmdCbG9ja0FwcHJvdmFsUmVxdWVzdCKtAQooRGVsZXRlQmlkZGluZ0Jsb2NrQXBwcm92YWxSZXF1ZXN0UmVxdWVzdBIUCgJpZBgBIAEoCUIIukgFcgOwAQESPwoTZXhwZWN0ZWRfdXBkYXRlZF9hdBgCIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBCBrpIA8gBARIeCgdjYXNlX2lkGAMgASgJQgi6SAVyA7ABAUgAiAEBQgoKCF9jYXNlX2lkIisKKURlbGV0ZUJpZGRpbmdCbG9ja0FwcHJvdmFsUmVxdWVzdFJlc3BvbnNlIpgCCipUcmFuc2l0aW9uQmlkZGluZ0Jsb2NrQXBwcm92YWxTdGF0ZVJlcXVlc3QSFAoCaWQYASABKAlCCLpIBXIDsAEBEj4KBmFjdGlvbhgCIAEoDjIiLmJmZnVzZXIudjEuQmlkZGluZ0xpZmVjeWNsZUFjdGlvbkIKukgHggEEEAEgABIcCgZyZWFzb24YAyABKAlCB7pIBHICGGRIAIgBARI/ChNleHBlY3RlZF91cGRhdGVkX2F0GAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEIGukgDyAEBEh4KB2Nhc2VfaWQYBSABKAlCCLpIBXIDsAEBSAGIAQFCCQoHX3JlYXNvbkIKCghfY2FzZV9pZCJwCitUcmFuc2l0aW9uQmlkZGluZ0Jsb2NrQXBwcm92YWxTdGF0ZVJlc3BvbnNlEkEKEGFwcHJvdmFsX3JlcXVlc3QYASABKAsyJy5iZmZ1c2VyLnYxLkJpZGRpbmdCbG9ja0FwcHJvdmFsUmVxdWVzdCKoAQojV2l0aGRyYXdCaWRkaW5nQmxvY2tCaWRHcm91cFJlcXVlc3QSFAoCaWQYASABKAlCCLpIBXIDsAEBEj8KE2V4cGVjdGVkX3VwZGF0ZWRfYXQYAiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wQga6SAPIAQESHgoHY2FzZV9pZBgDIAEoCUIIukgFcgOwAQFIAIgBAUIKCghfY2FzZV9pZCJpCiRXaXRoZHJhd0JpZGRpbmdCbG9ja0JpZEdyb3VwUmVzcG9uc2USQQoQYXBwcm92YWxfcmVxdWVzdBgBIAEoCzInLmJmZnVzZXIudjEuQmlkZGluZ0Jsb2NrQXBwcm92YWxSZXF1ZXN0IpQBCiRXaXRoZHJhd0JpZGRpbmdCbG9ja0JpZEdyb3Vwc1JlcXVlc3QSQAoHdGFyZ2V0cxgBIAMoCzIlLmJmZnVzZXIudjEuQmlkZGluZ0J1bGtXaXRoZHJhd1RhcmdldEIIukgFkgECCAESHgoHY2FzZV9pZBgCIAEoCUIIukgFcgOwAQFIAIgBAUIKCghfY2FzZV9pZCJoCiVXaXRoZHJhd0JpZGRpbmdCbG9ja0JpZEdyb3Vwc1Jlc3BvbnNlEj8KB3Jlc3VsdHMYASADKAsyLi5iZmZ1c2VyLnYxLldpdGhkcmF3QmlkZGluZ0Jsb2NrQmlkR3JvdXBSZXN1bHQiswEKIldpdGhkcmF3QmlkZGluZ0Jsb2NrQmlkR3JvdXBSZXN1bHQSCgoCaWQYASABKAkSOwoIYWNjZXB0ZWQYAiABKAsyJy5iZmZ1c2VyLnYxLkJpZGRpbmdCdWxrV2l0aGRyYXdBY2NlcHRlZEgAEjkKB2ZhaWx1cmUYAyABKAsyJi5iZmZ1c2VyLnYxLkJpZGRpbmdCdWxrV2l0aGRyYXdGYWlsdXJlSABCCQoHb3V0Y29tZSKlAgobQ2hlY2tCaWRkaW5nQmxvY2tDc3ZSZXF1ZXN0EiEKC2Nzdl9jb250ZW50GAEgASgMQgy6SAl6BxABGICAgBkSJAoNY3N2X2ZpbGVfbmFtZRgCIAEoCUIIukgFcgMY/wFIAIgBARI8Cgpncm91cF90eXBlGAMgASgOMiQuYmZmdXNlci52MS5CaWRkaW5nQmxvY2tCaWRHcm91cFR5cGVCAhgBEjoKDWFwcHJvdmFsX21vZGUYBCABKA4yHy5iZmZ1c2VyLnYxLkJpZGRpbmdBcHByb3ZhbE1vZGVCAhgBEjEKC2lzc3Vlcl90eXBlGAUgASgOMhguYmZmdHlwZXMudjEuTGljZW5zZVR5cGVCAhgBQhAKDl9jc3ZfZmlsZV9uYW1lIt8BChxDaGVja0JpZGRpbmdCbG9ja0NzdlJlc3BvbnNlEhMKC2NoZWNrX3Rva2VuGAEgASgJEjIKBHJvd3MYAiADKAsyJC5iZmZ1c2VyLnYxLkJpZGRpbmdCbG9ja0NzdlJvd1Jlc3VsdBIbChNjcmVhdGVkX2dyb3VwX2NvdW50GAMgASgFEhMKC2Vycm9yX2NvdW50GAQgASgFEiUKHWZlZV9hdXRvX2NvbnNpZGVyX3VuYXZhaWxhYmxlGAUgASgIEh0KFWR1cGxpY2F0ZV9ncm91cF9jb3VudBgGIAEoBSJrChtBcHBseUJpZGRpbmdCbG9ja0NzdlJlcXVlc3QSIAoLY2hlY2tfdG9rZW4YASABKAlCC4ABAbpIBXIDsAEBEh4KB2Nhc2VfaWQYAiABKAlCCLpIBXIDsAEBSACIAQFCCgoIX2Nhc2VfaWQiWQocQXBwbHlCaWRkaW5nQmxvY2tDc3ZSZXNwb25zZRIbChNjcmVhdGVkX2dyb3VwX2NvdW50GAEgASgFEhwKFGFwcHJvdmFsX3JlcXVlc3RfaWRzGAIgAygJIpoBCipBcHByb3ZlQmlkZGluZ0Jsb2NrQXBwcm92YWxSZXF1ZXN0c1JlcXVlc3QSQAoHdGFyZ2V0cxgBIAMoCzIlLmJmZnVzZXIudjEuQmlkZGluZ0J1bGtBcHByb3ZhbFRhcmdldEIIukgFkgECCAESHgoHY2FzZV9pZBgCIAEoCUIIukgFcgOwAQFIAIgBAUIKCghfY2FzZV9pZCJ0CitBcHByb3ZlQmlkZGluZ0Jsb2NrQXBwcm92YWxSZXF1ZXN0c1Jlc3BvbnNlEkUKB3Jlc3VsdHMYASADKAsyNC5iZmZ1c2VyLnYxLkFwcHJvdmVCaWRkaW5nQmxvY2tBcHByb3ZhbFJlcXVlc3RSZXN1bHQivgEKKEFwcHJvdmVCaWRkaW5nQmxvY2tBcHByb3ZhbFJlcXVlc3RSZXN1bHQSCgoCaWQYASABKAkSOwoIYXBwcm92ZWQYAiABKAsyJy5iZmZ1c2VyLnYxLkJpZGRpbmdCdWxrQXBwcm92YWxBcHByb3ZlZEgAEj4KB2ZhaWx1cmUYAyABKAsyKy5iZmZ1c2VyLnYxLkJpZGRpbmdCbG9ja0J1bGtBcHByb3ZhbEZhaWx1cmVIAEIJCgdvdXRjb21lIqUBCh9CaWRkaW5nQmxvY2tCdWxrQXBwcm92YWxGYWlsdXJlEjwKBnJlYXNvbhgBIAEoDjIsLmJmZnVzZXIudjEuQmlkZGluZ0J1bGtBcHByb3ZhbEZhaWx1cmVSZWFzb24SRAoUd3JpdGVfYmxvY2tlZF9yZWFzb24YAiABKA4yJi5iZmZ1c2VyLnYxLkJsb2NrQmlkV3JpdGVCbG9ja2VkUmVhc29uIn4KJUJpZGRpbmdCbG9ja1N1Ym1pc3Npb25EdXBsaWNhdGVUYXJnZXQSFAoCaWQYASABKAlCCLpIBXIDsAEBEj8KE2V4cGVjdGVkX3VwZGF0ZWRfYXQYAiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wQga6SAPIAQEiggEKLENoZWNrQmlkZGluZ0Jsb2NrU3VibWlzc2lvbkR1cGxpY2F0ZXNSZXF1ZXN0EkwKB3RhcmdldHMYAiADKAsyMS5iZmZ1c2VyLnYxLkJpZGRpbmdCbG9ja1N1Ym1pc3Npb25EdXBsaWNhdGVUYXJnZXRCCLpIBZIBAggBSgQIARACIk4KLUNoZWNrQmlkZGluZ0Jsb2NrU3VibWlzc2lvbkR1cGxpY2F0ZXNSZXNwb25zZRIdChVkdXBsaWNhdGVfZ3JvdXBfY291bnQYASABKAUysg0KE0JpZGRpbmdCbG9ja1NlcnZpY2USjwEKIExpc3RCaWRkaW5nQmxvY2tBcHByb3ZhbFJlcXVlc3RzEjMuYmZmdXNlci52MS5MaXN0QmlkZGluZ0Jsb2NrQXBwcm92YWxSZXF1ZXN0c1JlcXVlc3QaNC5iZmZ1c2VyLnYxLkxpc3RCaWRkaW5nQmxvY2tBcHByb3ZhbFJlcXVlc3RzUmVzcG9uc2UiABKJAQoeR2V0QmlkZGluZ0Jsb2NrQXBwcm92YWxSZXF1ZXN0EjEuYmZmdXNlci52MS5HZXRCaWRkaW5nQmxvY2tBcHByb3ZhbFJlcXVlc3RSZXF1ZXN0GjIuYmZmdXNlci52MS5HZXRCaWRkaW5nQmxvY2tBcHByb3ZhbFJlcXVlc3RSZXNwb25zZSIAEpIBCiFDcmVhdGVCaWRkaW5nQmxvY2tBcHByb3ZhbFJlcXVlc3QSNC5iZmZ1c2VyLnYxLkNyZWF0ZUJpZGRpbmdCbG9ja0FwcHJvdmFsUmVxdWVzdFJlcXVlc3QaNS5iZmZ1c2VyLnYxLkNyZWF0ZUJpZGRpbmdCbG9ja0FwcHJvdmFsUmVxdWVzdFJlc3BvbnNlIgASkgEKIVVwZGF0ZUJpZGRpbmdCbG9ja0FwcHJvdmFsUmVxdWVzdBI0LmJmZnVzZXIudjEuVXBkYXRlQmlkZGluZ0Jsb2NrQXBwcm92YWxSZXF1ZXN0UmVxdWVzdBo1LmJmZnVzZXIudjEuVXBkYXRlQmlkZGluZ0Jsb2NrQXBwcm92YWxSZXF1ZXN0UmVzcG9uc2UiABKSAQohRGVsZXRlQmlkZGluZ0Jsb2NrQXBwcm92YWxSZXF1ZXN0EjQuYmZmdXNlci52MS5EZWxldGVCaWRkaW5nQmxvY2tBcHByb3ZhbFJlcXVlc3RSZXF1ZXN0GjUuYmZmdXNlci52MS5EZWxldGVCaWRkaW5nQmxvY2tBcHByb3ZhbFJlcXVlc3RSZXNwb25zZSIAEpgBCiNUcmFuc2l0aW9uQmlkZGluZ0Jsb2NrQXBwcm92YWxTdGF0ZRI2LmJmZnVzZXIudjEuVHJhbnNpdGlvbkJpZGRpbmdCbG9ja0FwcHJvdmFsU3RhdGVSZXF1ZXN0GjcuYmZmdXNlci52MS5UcmFuc2l0aW9uQmlkZGluZ0Jsb2NrQXBwcm92YWxTdGF0ZVJlc3BvbnNlIgASgwEKHFdpdGhkcmF3QmlkZGluZ0Jsb2NrQmlkR3JvdXASLy5iZmZ1c2VyLnYxLldpdGhkcmF3QmlkZGluZ0Jsb2NrQmlkR3JvdXBSZXF1ZXN0GjAuYmZmdXNlci52MS5XaXRoZHJhd0JpZGRpbmdCbG9ja0JpZEdyb3VwUmVzcG9uc2UiABKGAQodV2l0aGRyYXdCaWRkaW5nQmxvY2tCaWRHcm91cHMSMC5iZmZ1c2VyLnYxLldpdGhkcmF3QmlkZGluZ0Jsb2NrQmlkR3JvdXBzUmVxdWVzdBoxLmJmZnVzZXIudjEuV2l0aGRyYXdCaWRkaW5nQmxvY2tCaWRHcm91cHNSZXNwb25zZSIAEmsKFENoZWNrQmlkZGluZ0Jsb2NrQ3N2EicuYmZmdXNlci52MS5DaGVja0JpZGRpbmdCbG9ja0NzdlJlcXVlc3QaKC5iZmZ1c2VyLnYxLkNoZWNrQmlkZGluZ0Jsb2NrQ3N2UmVzcG9uc2UiABJrChRBcHBseUJpZGRpbmdCbG9ja0NzdhInLmJmZnVzZXIudjEuQXBwbHlCaWRkaW5nQmxvY2tDc3ZSZXF1ZXN0GiguYmZmdXNlci52MS5BcHBseUJpZGRpbmdCbG9ja0NzdlJlc3BvbnNlIgASmAEKI0FwcHJvdmVCaWRkaW5nQmxvY2tBcHByb3ZhbFJlcXVlc3RzEjYuYmZmdXNlci52MS5BcHByb3ZlQmlkZGluZ0Jsb2NrQXBwcm92YWxSZXF1ZXN0c1JlcXVlc3QaNy5iZmZ1c2VyLnYxLkFwcHJvdmVCaWRkaW5nQmxvY2tBcHByb3ZhbFJlcXVlc3RzUmVzcG9uc2UiABKeAQolQ2hlY2tCaWRkaW5nQmxvY2tTdWJtaXNzaW9uRHVwbGljYXRlcxI4LmJmZnVzZXIudjEuQ2hlY2tCaWRkaW5nQmxvY2tTdWJtaXNzaW9uRHVwbGljYXRlc1JlcXVlc3QaOS5iZmZ1c2VyLnYxLkNoZWNrQmlkZGluZ0Jsb2NrU3VibWlzc2lvbkR1cGxpY2F0ZXNSZXNwb25zZSIAQkBaPmdpdGh1Yi5jb20vZW5lY2hhaW4vZWJhbGFuY2UvZ28vZ2VuL3Byb3RvL2JmZnVzZXIvdjE7YmZmdXNlcnYxYgZwcm90bzM", [file_bfftypes_v1_license_type, file_bffuser_v1_bidding_block_model, file_bffuser_v1_bidding_common_model, file_buf_validate_validate, file_google_protobuf_timestamp, file_google_type_date]);

/**
 * @generated from message bffuser.v1.ListBiddingBlockApprovalRequestsRequest
 */
export type ListBiddingBlockApprovalRequestsRequest = Message<"bffuser.v1.ListBiddingBlockApprovalRequestsRequest"> & {
  /**
   * @generated from field: optional google.type.Date target_date_filter = 1;
   */
  targetDateFilter?: Date;
};

/**
 * Describes the message bffuser.v1.ListBiddingBlockApprovalRequestsRequest.
 * Use `create(ListBiddingBlockApprovalRequestsRequestSchema)` to create a new message.
 */
export const ListBiddingBlockApprovalRequestsRequestSchema: GenMessage<ListBiddingBlockApprovalRequestsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_block_service, 0);

/**
 * @generated from message bffuser.v1.ListBiddingBlockApprovalRequestsResponse
 */
export type ListBiddingBlockApprovalRequestsResponse = Message<"bffuser.v1.ListBiddingBlockApprovalRequestsResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.BiddingBlockApprovalRequestListItem items = 1;
   */
  items: BiddingBlockApprovalRequestListItem[];
};

/**
 * Describes the message bffuser.v1.ListBiddingBlockApprovalRequestsResponse.
 * Use `create(ListBiddingBlockApprovalRequestsResponseSchema)` to create a new message.
 */
export const ListBiddingBlockApprovalRequestsResponseSchema: GenMessage<ListBiddingBlockApprovalRequestsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_block_service, 1);

/**
 * @generated from message bffuser.v1.GetBiddingBlockApprovalRequestRequest
 */
export type GetBiddingBlockApprovalRequestRequest = Message<"bffuser.v1.GetBiddingBlockApprovalRequestRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message bffuser.v1.GetBiddingBlockApprovalRequestRequest.
 * Use `create(GetBiddingBlockApprovalRequestRequestSchema)` to create a new message.
 */
export const GetBiddingBlockApprovalRequestRequestSchema: GenMessage<GetBiddingBlockApprovalRequestRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_block_service, 2);

/**
 * @generated from message bffuser.v1.GetBiddingBlockApprovalRequestResponse
 */
export type GetBiddingBlockApprovalRequestResponse = Message<"bffuser.v1.GetBiddingBlockApprovalRequestResponse"> & {
  /**
   * @generated from field: bffuser.v1.BiddingBlockApprovalRequest approval_request = 1;
   */
  approvalRequest?: BiddingBlockApprovalRequest;
};

/**
 * Describes the message bffuser.v1.GetBiddingBlockApprovalRequestResponse.
 * Use `create(GetBiddingBlockApprovalRequestResponseSchema)` to create a new message.
 */
export const GetBiddingBlockApprovalRequestResponseSchema: GenMessage<GetBiddingBlockApprovalRequestResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_block_service, 3);

/**
 * @generated from message bffuser.v1.CreateBiddingBlockApprovalRequestRequest
 */
export type CreateBiddingBlockApprovalRequestRequest = Message<"bffuser.v1.CreateBiddingBlockApprovalRequestRequest"> & {
  /**
   * @generated from field: google.type.Date target_date = 1;
   */
  targetDate?: Date;

  /**
   * @generated from field: bffuser.v1.BiddingApprovalMode approval_mode = 2;
   */
  approvalMode: BiddingApprovalMode;

  /**
   * グループ種別 (= BLOCK / LINK_BLOCK / LOOP_BLOCK)。
   *
   * @generated from field: bffuser.v1.BiddingBlockBidGroupType group_type = 3;
   */
  groupType: BiddingBlockBidGroupType;

  /**
   * Leg 明細。 STANDARD は primary のみ、 LINK / LOOP は primary + secondary。
   *
   * @generated from field: bffuser.v1.BiddingBlockBidInput primary = 4;
   */
  primary?: BiddingBlockBidInput;

  /**
   * @generated from field: optional bffuser.v1.BiddingBlockBidInput secondary = 5;
   */
  secondary?: BiddingBlockBidInput;

  /**
   * 発注主体 (= どの名義で JEPX に発注するか)。 グループ単位 (= 全 leg 共通)。
   *
   * @generated from field: bfftypes.v1.LicenseType issuer_type = 6;
   */
  issuerType: LicenseType;

  /**
   * 操作元の業務ワークフローケース ID。 拒否の扱いは CreateBiddingSpotApprovalRequestRequest.case_id と同じ。
   * 拒否しなければ、 当該ケースの業務 ID をグループを作ったワークフローとして記録する (AC-BSP-058。
   * internalapi.v1.CreateBlockBidApprovalRequestRequest.case_id)。
   *
   * @generated from field: optional string case_id = 7;
   */
  caseId?: string;
};

/**
 * Describes the message bffuser.v1.CreateBiddingBlockApprovalRequestRequest.
 * Use `create(CreateBiddingBlockApprovalRequestRequestSchema)` to create a new message.
 */
export const CreateBiddingBlockApprovalRequestRequestSchema: GenMessage<CreateBiddingBlockApprovalRequestRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_block_service, 4);

/**
 * @generated from message bffuser.v1.CreateBiddingBlockApprovalRequestResponse
 */
export type CreateBiddingBlockApprovalRequestResponse = Message<"bffuser.v1.CreateBiddingBlockApprovalRequestResponse"> & {
  /**
   * @generated from field: bffuser.v1.BiddingBlockApprovalRequest approval_request = 1;
   */
  approvalRequest?: BiddingBlockApprovalRequest;
};

/**
 * Describes the message bffuser.v1.CreateBiddingBlockApprovalRequestResponse.
 * Use `create(CreateBiddingBlockApprovalRequestResponseSchema)` to create a new message.
 */
export const CreateBiddingBlockApprovalRequestResponseSchema: GenMessage<CreateBiddingBlockApprovalRequestResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_block_service, 5);

/**
 * @generated from message bffuser.v1.UpdateBiddingBlockApprovalRequestRequest
 */
export type UpdateBiddingBlockApprovalRequestRequest = Message<"bffuser.v1.UpdateBiddingBlockApprovalRequestRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: bffuser.v1.BiddingApprovalMode approval_mode = 2;
   */
  approvalMode: BiddingApprovalMode;

  /**
   * 差し替え後の leg 明細一式 (= group_type は変更できない)。
   *
   * @generated from field: bffuser.v1.BiddingBlockBidInput primary = 3;
   */
  primary?: BiddingBlockBidInput;

  /**
   * @generated from field: optional bffuser.v1.BiddingBlockBidInput secondary = 5;
   */
  secondary?: BiddingBlockBidInput;

  /**
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 4;
   */
  expectedUpdatedAt?: Timestamp;

  /**
   * 発注主体。 編集でも変更できる (= 名義を選び直せる)。
   *
   * @generated from field: bfftypes.v1.LicenseType issuer_type = 6;
   */
  issuerType: LicenseType;

  /**
   * 操作元の業務ワークフローケース ID。 扱いは CreateBiddingSpotApprovalRequestRequest.case_id と同じ (#8265)。
   * 加えて、 グループを作ったワークフローが完了済なら、 case_id の有無・値にかかわらず拒否する
   * (AC-BSP-058。 internalapi.v1.UpdateBlockBidApprovalRequestRequest.case_id)。
   *
   * @generated from field: optional string case_id = 7;
   */
  caseId?: string;
};

/**
 * Describes the message bffuser.v1.UpdateBiddingBlockApprovalRequestRequest.
 * Use `create(UpdateBiddingBlockApprovalRequestRequestSchema)` to create a new message.
 */
export const UpdateBiddingBlockApprovalRequestRequestSchema: GenMessage<UpdateBiddingBlockApprovalRequestRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_block_service, 6);

/**
 * @generated from message bffuser.v1.UpdateBiddingBlockApprovalRequestResponse
 */
export type UpdateBiddingBlockApprovalRequestResponse = Message<"bffuser.v1.UpdateBiddingBlockApprovalRequestResponse"> & {
  /**
   * @generated from field: bffuser.v1.BiddingBlockApprovalRequest approval_request = 1;
   */
  approvalRequest?: BiddingBlockApprovalRequest;
};

/**
 * Describes the message bffuser.v1.UpdateBiddingBlockApprovalRequestResponse.
 * Use `create(UpdateBiddingBlockApprovalRequestResponseSchema)` to create a new message.
 */
export const UpdateBiddingBlockApprovalRequestResponseSchema: GenMessage<UpdateBiddingBlockApprovalRequestResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_block_service, 7);

/**
 * @generated from message bffuser.v1.DeleteBiddingBlockApprovalRequestRequest
 */
export type DeleteBiddingBlockApprovalRequestRequest = Message<"bffuser.v1.DeleteBiddingBlockApprovalRequestRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 2;
   */
  expectedUpdatedAt?: Timestamp;

  /**
   * 操作元の業務ワークフローケース ID。 扱いは UpdateBiddingBlockApprovalRequestRequest.case_id と同じ
   * (グループを作ったワークフローが完了済なら拒否する)。
   *
   * @generated from field: optional string case_id = 3;
   */
  caseId?: string;
};

/**
 * Describes the message bffuser.v1.DeleteBiddingBlockApprovalRequestRequest.
 * Use `create(DeleteBiddingBlockApprovalRequestRequestSchema)` to create a new message.
 */
export const DeleteBiddingBlockApprovalRequestRequestSchema: GenMessage<DeleteBiddingBlockApprovalRequestRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_block_service, 8);

/**
 * @generated from message bffuser.v1.DeleteBiddingBlockApprovalRequestResponse
 */
export type DeleteBiddingBlockApprovalRequestResponse = Message<"bffuser.v1.DeleteBiddingBlockApprovalRequestResponse"> & {
};

/**
 * Describes the message bffuser.v1.DeleteBiddingBlockApprovalRequestResponse.
 * Use `create(DeleteBiddingBlockApprovalRequestResponseSchema)` to create a new message.
 */
export const DeleteBiddingBlockApprovalRequestResponseSchema: GenMessage<DeleteBiddingBlockApprovalRequestResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_block_service, 9);

/**
 * @generated from message bffuser.v1.TransitionBiddingBlockApprovalStateRequest
 */
export type TransitionBiddingBlockApprovalStateRequest = Message<"bffuser.v1.TransitionBiddingBlockApprovalStateRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: bffuser.v1.BiddingLifecycleAction action = 2;
   */
  action: BiddingLifecycleAction;

  /**
   * 差戻し理由。 action=REJECT のみ参照 (= REJECT 時 min_len=1 を usecase で検証)。
   * 上限は 100 文字 (input-character-limits.md の説明・メモ系 / approval-tasks.md の差戻しコメントと同値)。
   *
   * @generated from field: optional string reason = 3;
   */
  reason?: string;

  /**
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 4;
   */
  expectedUpdatedAt?: Timestamp;

  /**
   * 操作元の業務ワークフローケース ID。 扱いは CreateBiddingSpotApprovalRequestRequest.case_id と同じで、
   * 全 action に掛ける。 加えて action が CANCEL / REOPEN / WITHDRAW (予約取消) / RETURN_TO_DRAFT の時は、
   * グループを作ったワークフローが完了済なら case_id の有無・値にかかわらず拒否する
   * (AC-BSP-058。 internalapi.v1.TransitionBlockBidApprovalStateRequest.case_id)。
   *
   * @generated from field: optional string case_id = 5;
   */
  caseId?: string;
};

/**
 * Describes the message bffuser.v1.TransitionBiddingBlockApprovalStateRequest.
 * Use `create(TransitionBiddingBlockApprovalStateRequestSchema)` to create a new message.
 */
export const TransitionBiddingBlockApprovalStateRequestSchema: GenMessage<TransitionBiddingBlockApprovalStateRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_block_service, 10);

/**
 * @generated from message bffuser.v1.TransitionBiddingBlockApprovalStateResponse
 */
export type TransitionBiddingBlockApprovalStateResponse = Message<"bffuser.v1.TransitionBiddingBlockApprovalStateResponse"> & {
  /**
   * @generated from field: bffuser.v1.BiddingBlockApprovalRequest approval_request = 1;
   */
  approvalRequest?: BiddingBlockApprovalRequest;
};

/**
 * Describes the message bffuser.v1.TransitionBiddingBlockApprovalStateResponse.
 * Use `create(TransitionBiddingBlockApprovalStateResponseSchema)` to create a new message.
 */
export const TransitionBiddingBlockApprovalStateResponseSchema: GenMessage<TransitionBiddingBlockApprovalStateResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_block_service, 11);

/**
 * 取下要求 (BFF)。
 *
 * @generated from message bffuser.v1.WithdrawBiddingBlockBidGroupRequest
 */
export type WithdrawBiddingBlockBidGroupRequest = Message<"bffuser.v1.WithdrawBiddingBlockBidGroupRequest"> & {
  /**
   * 取り下げるブロック入札グループ (= BiddingBlockApprovalRequest) の id。
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 楽観ロック基準値 (= グループの updated_at)。
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 2;
   */
  expectedUpdatedAt?: Timestamp;

  /**
   * 操作元の業務ワークフローケース ID。 扱いは UpdateBiddingBlockApprovalRequestRequest.case_id と同じ
   * (グループを作ったワークフローが完了済なら拒否する)。
   *
   * @generated from field: optional string case_id = 3;
   */
  caseId?: string;
};

/**
 * Describes the message bffuser.v1.WithdrawBiddingBlockBidGroupRequest.
 * Use `create(WithdrawBiddingBlockBidGroupRequestSchema)` to create a new message.
 */
export const WithdrawBiddingBlockBidGroupRequestSchema: GenMessage<WithdrawBiddingBlockBidGroupRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_block_service, 12);

/**
 * @generated from message bffuser.v1.WithdrawBiddingBlockBidGroupResponse
 */
export type WithdrawBiddingBlockBidGroupResponse = Message<"bffuser.v1.WithdrawBiddingBlockBidGroupResponse"> & {
  /**
   * @generated from field: bffuser.v1.BiddingBlockApprovalRequest approval_request = 1;
   */
  approvalRequest?: BiddingBlockApprovalRequest;
};

/**
 * Describes the message bffuser.v1.WithdrawBiddingBlockBidGroupResponse.
 * Use `create(WithdrawBiddingBlockBidGroupResponseSchema)` to create a new message.
 */
export const WithdrawBiddingBlockBidGroupResponseSchema: GenMessage<WithdrawBiddingBlockBidGroupResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_block_service, 13);

/**
 * 入札中のブロック入札グループの一括取下の要求 (BFF)。
 *
 * @generated from message bffuser.v1.WithdrawBiddingBlockBidGroupsRequest
 */
export type WithdrawBiddingBlockBidGroupsRequest = Message<"bffuser.v1.WithdrawBiddingBlockBidGroupsRequest"> & {
  /**
   * 取り下げるグループ。 expected_updated_at はグループの updated_at。
   *
   * @generated from field: repeated bffuser.v1.BiddingBulkWithdrawTarget targets = 1;
   */
  targets: BiddingBulkWithdrawTarget[];

  /**
   * 操作元の業務ワークフローケース ID。 拒否する時はグループごとの結果を返さずリクエスト全体を拒否する
   * (AC-BSP-058 / AC-BSP-116)。
   *
   * @generated from field: optional string case_id = 2;
   */
  caseId?: string;
};

/**
 * Describes the message bffuser.v1.WithdrawBiddingBlockBidGroupsRequest.
 * Use `create(WithdrawBiddingBlockBidGroupsRequestSchema)` to create a new message.
 */
export const WithdrawBiddingBlockBidGroupsRequestSchema: GenMessage<WithdrawBiddingBlockBidGroupsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_block_service, 14);

/**
 * @generated from message bffuser.v1.WithdrawBiddingBlockBidGroupsResponse
 */
export type WithdrawBiddingBlockBidGroupsResponse = Message<"bffuser.v1.WithdrawBiddingBlockBidGroupsResponse"> & {
  /**
   * request の targets と同じ順・同じ件数。
   *
   * @generated from field: repeated bffuser.v1.WithdrawBiddingBlockBidGroupResult results = 1;
   */
  results: WithdrawBiddingBlockBidGroupResult[];
};

/**
 * Describes the message bffuser.v1.WithdrawBiddingBlockBidGroupsResponse.
 * Use `create(WithdrawBiddingBlockBidGroupsResponseSchema)` to create a new message.
 */
export const WithdrawBiddingBlockBidGroupsResponseSchema: GenMessage<WithdrawBiddingBlockBidGroupsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_block_service, 15);

/**
 * @generated from message bffuser.v1.WithdrawBiddingBlockBidGroupResult
 */
export type WithdrawBiddingBlockBidGroupResult = Message<"bffuser.v1.WithdrawBiddingBlockBidGroupResult"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from oneof bffuser.v1.WithdrawBiddingBlockBidGroupResult.outcome
   */
  outcome: {
    /**
     * 取下を受け付けたグループ (全 leg が取下処理中)。
     *
     * @generated from field: bffuser.v1.BiddingBulkWithdrawAccepted accepted = 2;
     */
    value: BiddingBulkWithdrawAccepted;
    case: "accepted";
  } | {
    /**
     * @generated from field: bffuser.v1.BiddingBulkWithdrawFailure failure = 3;
     */
    value: BiddingBulkWithdrawFailure;
    case: "failure";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message bffuser.v1.WithdrawBiddingBlockBidGroupResult.
 * Use `create(WithdrawBiddingBlockBidGroupResultSchema)` to create a new message.
 */
export const WithdrawBiddingBlockBidGroupResultSchema: GenMessage<WithdrawBiddingBlockBidGroupResult> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_block_service, 16);

/**
 * ブロック入札 CSV のチェック要求 (BFF)。
 *
 * @generated from message bffuser.v1.CheckBiddingBlockCsvRequest
 */
export type CheckBiddingBlockCsvRequest = Message<"bffuser.v1.CheckBiddingBlockCsvRequest"> & {
  /**
   * CSV ファイルの生バイト列 (UTF-8 BOM / UTF-8 / Shift_JIS)。 業務上の上限 20 MB
   * (spot-bid-block-csv-import.md §5 / common.md、 ファイルサイズのみで制限し
   * 行数・削除件数の上限は設けない。 2026-09-25 PdM 決定) は、 上限と選択したファイルの
   * サイズを含む文言で backend が返す (common.md §4、 #9333)。 ここは入札 CSV 共通の
   * 50 MB で受ける (= 20 MB 超を validate の汎用文言で落とさない)。
   *
   * @generated from field: bytes csv_content = 1;
   */
  csvContent: Uint8Array;

  /**
   * 投入 CSV ファイル名。任意。
   *
   * @generated from field: optional string csv_file_name = 2;
   */
  csvFileName?: string;

  /**
   * 廃止: 列構成 (56 列 / 58 列) は CSV のヘッダーで決まり、 リンクブロックとループの
   * どちらとして取り込むかはブロック種別の値で決まる (spot-bid-block-csv-import.md
   * AC-DSB-012 / AC-DSB-013)。 backend へは送らない。
   *
   * @generated from field: bffuser.v1.BiddingBlockBidGroupType group_type = 3 [deprecated = true];
   * @deprecated
   */
  groupType: BiddingBlockBidGroupType;

  /**
   * 廃止: 承認モードは画面から受け取らず、 確定時に行ごとのエリアの承認フロー
   * 設定から backend が解決する (issue #8620、 spec spot-bid-block-csv-import.md
   * §5)。 BFF はこの値を読まない。 backend へは、 反映の順序によらず旧 backend の
   * 必須検証を通すための固定値 (要承認) を送り続けるが、 backend もそれを読まない。
   *
   * @generated from field: bffuser.v1.BiddingApprovalMode approval_mode = 4 [deprecated = true];
   * @deprecated
   */
  approvalMode: BiddingApprovalMode;

  /**
   * 廃止: 発注主体区分は CSV の行ごとの列になった (spot-bid-block-csv-import.md AC-DSB-016)。
   * backend へは送らない。
   *
   * @generated from field: bfftypes.v1.LicenseType issuer_type = 5 [deprecated = true];
   * @deprecated
   */
  issuerType: LicenseType;
};

/**
 * Describes the message bffuser.v1.CheckBiddingBlockCsvRequest.
 * Use `create(CheckBiddingBlockCsvRequestSchema)` to create a new message.
 */
export const CheckBiddingBlockCsvRequestSchema: GenMessage<CheckBiddingBlockCsvRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_block_service, 17);

/**
 * @generated from message bffuser.v1.CheckBiddingBlockCsvResponse
 */
export type CheckBiddingBlockCsvResponse = Message<"bffuser.v1.CheckBiddingBlockCsvResponse"> & {
  /**
   * 引換券。 ApplyBiddingBlockCsv に渡す。 有効期限 10 分・1 回消費。
   *
   * @generated from field: string check_token = 1;
   */
  checkToken: string;

  /**
   * 行ごとの差分プレビュー (CSV のデータ行順)。
   *
   * @generated from field: repeated bffuser.v1.BiddingBlockCsvRowResult rows = 2;
   */
  rows: BiddingBlockCsvRowResult[];

  /**
   * 新規グループ数 (= 取込対象。 LINK / LOOP はペアで 1)。
   *
   * @generated from field: int32 created_group_count = 3;
   */
  createdGroupCount: number;

  /**
   * エラー行数。 > 0 なら確定は全体拒否される。
   *
   * @generated from field: int32 error_count = 4;
   */
  errorCount: number;

  /**
   * 手数料自動考慮（スポット）が ON で手数料単価を取得できていない
   * (AC-BSP-004b)。 true の間、 client は確定ボタンを無効化する。
   *
   * @generated from field: bool fee_auto_consider_unavailable = 5;
   */
  feeAutoConsiderUnavailable: boolean;

  /**
   * 既存の札と重複するグループの数 (AC-DSB-034。 リンクブロック・ループはペアで 1)。
   * 警告があっても確定は止めない。
   *
   * @generated from field: int32 duplicate_group_count = 6;
   */
  duplicateGroupCount: number;
};

/**
 * Describes the message bffuser.v1.CheckBiddingBlockCsvResponse.
 * Use `create(CheckBiddingBlockCsvResponseSchema)` to create a new message.
 */
export const CheckBiddingBlockCsvResponseSchema: GenMessage<CheckBiddingBlockCsvResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_block_service, 18);

/**
 * @generated from message bffuser.v1.ApplyBiddingBlockCsvRequest
 */
export type ApplyBiddingBlockCsvRequest = Message<"bffuser.v1.ApplyBiddingBlockCsvRequest"> & {
  /**
   * CheckBiddingBlockCsvResponse.check_token。
   *
   * @generated from field: string check_token = 1;
   */
  checkToken: string;

  /**
   * 操作元の業務ワークフローケース ID。 拒否の扱いは ApplyBiddingSpotNormalCsvRequest.case_id と同じ。
   * 加えて、 当該ケースの対象日のグループには当該ケースの業務 ID を記録する (AC-BSP-058。
   * internalapi.v1.ApplyBlockBidCsvRequest.case_id)。
   *
   * @generated from field: optional string case_id = 2;
   */
  caseId?: string;
};

/**
 * Describes the message bffuser.v1.ApplyBiddingBlockCsvRequest.
 * Use `create(ApplyBiddingBlockCsvRequestSchema)` to create a new message.
 */
export const ApplyBiddingBlockCsvRequestSchema: GenMessage<ApplyBiddingBlockCsvRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_block_service, 19);

/**
 * @generated from message bffuser.v1.ApplyBiddingBlockCsvResponse
 */
export type ApplyBiddingBlockCsvResponse = Message<"bffuser.v1.ApplyBiddingBlockCsvResponse"> & {
  /**
   * 実際に作成したグループ数。
   *
   * @generated from field: int32 created_group_count = 1;
   */
  createdGroupCount: number;

  /**
   * 作成した承認依頼の ID (= グループごとに 1 件)。
   *
   * @generated from field: repeated string approval_request_ids = 2;
   */
  approvalRequestIds: string[];
};

/**
 * Describes the message bffuser.v1.ApplyBiddingBlockCsvResponse.
 * Use `create(ApplyBiddingBlockCsvResponseSchema)` to create a new message.
 */
export const ApplyBiddingBlockCsvResponseSchema: GenMessage<ApplyBiddingBlockCsvResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_block_service, 20);

/**
 * まとめて承認の要求 (BFF)。
 *
 * @generated from message bffuser.v1.ApproveBiddingBlockApprovalRequestsRequest
 */
export type ApproveBiddingBlockApprovalRequestsRequest = Message<"bffuser.v1.ApproveBiddingBlockApprovalRequestsRequest"> & {
  /**
   * 承認する案件 (ブロック 1 グループ。 リンク・ループはペアで 1 件)。
   *
   * @generated from field: repeated bffuser.v1.BiddingBulkApprovalTarget targets = 1;
   */
  targets: BiddingBulkApprovalTarget[];

  /**
   * 操作元の業務ワークフローケース ID。 扱いは ApproveBiddingSpotApprovalRequestsRequest.case_id と同じ。
   *
   * @generated from field: optional string case_id = 2;
   */
  caseId?: string;
};

/**
 * Describes the message bffuser.v1.ApproveBiddingBlockApprovalRequestsRequest.
 * Use `create(ApproveBiddingBlockApprovalRequestsRequestSchema)` to create a new message.
 */
export const ApproveBiddingBlockApprovalRequestsRequestSchema: GenMessage<ApproveBiddingBlockApprovalRequestsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_block_service, 21);

/**
 * @generated from message bffuser.v1.ApproveBiddingBlockApprovalRequestsResponse
 */
export type ApproveBiddingBlockApprovalRequestsResponse = Message<"bffuser.v1.ApproveBiddingBlockApprovalRequestsResponse"> & {
  /**
   * request の targets と同じ順・同じ件数。
   *
   * @generated from field: repeated bffuser.v1.ApproveBiddingBlockApprovalRequestResult results = 1;
   */
  results: ApproveBiddingBlockApprovalRequestResult[];
};

/**
 * Describes the message bffuser.v1.ApproveBiddingBlockApprovalRequestsResponse.
 * Use `create(ApproveBiddingBlockApprovalRequestsResponseSchema)` to create a new message.
 */
export const ApproveBiddingBlockApprovalRequestsResponseSchema: GenMessage<ApproveBiddingBlockApprovalRequestsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_block_service, 22);

/**
 * @generated from message bffuser.v1.ApproveBiddingBlockApprovalRequestResult
 */
export type ApproveBiddingBlockApprovalRequestResult = Message<"bffuser.v1.ApproveBiddingBlockApprovalRequestResult"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from oneof bffuser.v1.ApproveBiddingBlockApprovalRequestResult.outcome
   */
  outcome: {
    /**
     * 承認した案件 (ブロック入札は多段階承認を持たないので常に承認済)。
     *
     * @generated from field: bffuser.v1.BiddingBulkApprovalApproved approved = 2;
     */
    value: BiddingBulkApprovalApproved;
    case: "approved";
  } | {
    /**
     * @generated from field: bffuser.v1.BiddingBlockBulkApprovalFailure failure = 3;
     */
    value: BiddingBlockBulkApprovalFailure;
    case: "failure";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message bffuser.v1.ApproveBiddingBlockApprovalRequestResult.
 * Use `create(ApproveBiddingBlockApprovalRequestResultSchema)` to create a new message.
 */
export const ApproveBiddingBlockApprovalRequestResultSchema: GenMessage<ApproveBiddingBlockApprovalRequestResult> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_block_service, 23);

/**
 * @generated from message bffuser.v1.BiddingBlockBulkApprovalFailure
 */
export type BiddingBlockBulkApprovalFailure = Message<"bffuser.v1.BiddingBlockBulkApprovalFailure"> & {
  /**
   * @generated from field: bffuser.v1.BiddingBulkApprovalFailureReason reason = 1;
   */
  reason: BiddingBulkApprovalFailureReason;

  /**
   * reason = BID_LIMIT_VIOLATION の時の詳細 (それ以外は UNSPECIFIED)。
   *
   * @generated from field: bffuser.v1.BlockBidWriteBlockedReason write_blocked_reason = 2;
   */
  writeBlockedReason: BlockBidWriteBlockedReason;
};

/**
 * Describes the message bffuser.v1.BiddingBlockBulkApprovalFailure.
 * Use `create(BiddingBlockBulkApprovalFailureSchema)` to create a new message.
 */
export const BiddingBlockBulkApprovalFailureSchema: GenMessage<BiddingBlockBulkApprovalFailure> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_block_service, 24);

/**
 * @generated from message bffuser.v1.BiddingBlockSubmissionDuplicateTarget
 */
export type BiddingBlockSubmissionDuplicateTarget = Message<"bffuser.v1.BiddingBlockSubmissionDuplicateTarget"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 2;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.BiddingBlockSubmissionDuplicateTarget.
 * Use `create(BiddingBlockSubmissionDuplicateTargetSchema)` to create a new message.
 */
export const BiddingBlockSubmissionDuplicateTargetSchema: GenMessage<BiddingBlockSubmissionDuplicateTarget> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_block_service, 25);

/**
 * @generated from message bffuser.v1.CheckBiddingBlockSubmissionDuplicatesRequest
 */
export type CheckBiddingBlockSubmissionDuplicatesRequest = Message<"bffuser.v1.CheckBiddingBlockSubmissionDuplicatesRequest"> & {
  /**
   * @generated from field: repeated bffuser.v1.BiddingBlockSubmissionDuplicateTarget targets = 2;
   */
  targets: BiddingBlockSubmissionDuplicateTarget[];
};

/**
 * Describes the message bffuser.v1.CheckBiddingBlockSubmissionDuplicatesRequest.
 * Use `create(CheckBiddingBlockSubmissionDuplicatesRequestSchema)` to create a new message.
 */
export const CheckBiddingBlockSubmissionDuplicatesRequestSchema: GenMessage<CheckBiddingBlockSubmissionDuplicatesRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_block_service, 26);

/**
 * @generated from message bffuser.v1.CheckBiddingBlockSubmissionDuplicatesResponse
 */
export type CheckBiddingBlockSubmissionDuplicatesResponse = Message<"bffuser.v1.CheckBiddingBlockSubmissionDuplicatesResponse"> & {
  /**
   * @generated from field: int32 duplicate_group_count = 1;
   */
  duplicateGroupCount: number;
};

/**
 * Describes the message bffuser.v1.CheckBiddingBlockSubmissionDuplicatesResponse.
 * Use `create(CheckBiddingBlockSubmissionDuplicatesResponseSchema)` to create a new message.
 */
export const CheckBiddingBlockSubmissionDuplicatesResponseSchema: GenMessage<CheckBiddingBlockSubmissionDuplicatesResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_block_service, 27);

/**
 * ブロック入札 承認依頼を frontend 向けに提供する service。
 *
 * @generated from service bffuser.v1.BiddingBlockService
 */
export const BiddingBlockService: GenService<{
  /**
   * 承認依頼の一覧。
   *
   * @generated from rpc bffuser.v1.BiddingBlockService.ListBiddingBlockApprovalRequests
   */
  listBiddingBlockApprovalRequests: {
    methodKind: "unary";
    input: typeof ListBiddingBlockApprovalRequestsRequestSchema;
    output: typeof ListBiddingBlockApprovalRequestsResponseSchema;
  },
  /**
   * 承認依頼 1 件 + 全 BlockBid (leg) 明細を取得。
   *
   * @generated from rpc bffuser.v1.BiddingBlockService.GetBiddingBlockApprovalRequest
   */
  getBiddingBlockApprovalRequest: {
    methodKind: "unary";
    input: typeof GetBiddingBlockApprovalRequestRequestSchema;
    output: typeof GetBiddingBlockApprovalRequestResponseSchema;
  },
  /**
   * 承認依頼を新規作成。
   *
   * @generated from rpc bffuser.v1.BiddingBlockService.CreateBiddingBlockApprovalRequest
   */
  createBiddingBlockApprovalRequest: {
    methodKind: "unary";
    input: typeof CreateBiddingBlockApprovalRequestRequestSchema;
    output: typeof CreateBiddingBlockApprovalRequestResponseSchema;
  },
  /**
   * 下書きの更新。 楽観ロック使用。
   *
   * @generated from rpc bffuser.v1.BiddingBlockService.UpdateBiddingBlockApprovalRequest
   */
  updateBiddingBlockApprovalRequest: {
    methodKind: "unary";
    input: typeof UpdateBiddingBlockApprovalRequestRequestSchema;
    output: typeof UpdateBiddingBlockApprovalRequestResponseSchema;
  },
  /**
   * 下書きの削除。 楽観ロック使用。
   *
   * @generated from rpc bffuser.v1.BiddingBlockService.DeleteBiddingBlockApprovalRequest
   */
  deleteBiddingBlockApprovalRequest: {
    methodKind: "unary";
    input: typeof DeleteBiddingBlockApprovalRequestRequestSchema;
    output: typeof DeleteBiddingBlockApprovalRequestResponseSchema;
  },
  /**
   * 承認ワークフローの状態遷移 (= 承認申請 / 承認 / 差戻し / 申請取消 / JEPX 提出 / 予約取消 を action で指定)。
   * 予約取消 (WITHDRAW) は予約中の札だけ有効 (AC-BSP-092)。
   * 楽観ロック使用。
   *
   * @generated from rpc bffuser.v1.BiddingBlockService.TransitionBiddingBlockApprovalState
   */
  transitionBiddingBlockApprovalState: {
    methodKind: "unary";
    input: typeof TransitionBiddingBlockApprovalStateRequestSchema;
    output: typeof TransitionBiddingBlockApprovalStateResponseSchema;
  },
  /**
   * 入札中のブロック入札グループを入札締切前に取り下げる (AC-BSP-057)。
   * グループ単位 (LINK-P + LINK-C / LOOP-A + LOOP-B は不可分)。 楽観ロック使用。
   *
   * @generated from rpc bffuser.v1.BiddingBlockService.WithdrawBiddingBlockBidGroup
   */
  withdrawBiddingBlockBidGroup: {
    methodKind: "unary";
    input: typeof WithdrawBiddingBlockBidGroupRequestSchema;
    output: typeof WithdrawBiddingBlockBidGroupResponseSchema;
  },
  /**
   * 入札中のブロック入札グループの一括取下 (AC-BSP-116)。 件数の上限は無い。 1 トランザクションでまとめて
   * 全 leg を取下処理中にし、 取下できなかったグループは理由を results に返す。 error 応答ならどのグループも
   * 取り下げていない (通信の失敗では結果不明なので一覧を読み直す)。
   *
   * @generated from rpc bffuser.v1.BiddingBlockService.WithdrawBiddingBlockBidGroups
   */
  withdrawBiddingBlockBidGroups: {
    methodKind: "unary";
    input: typeof WithdrawBiddingBlockBidGroupsRequestSchema;
    output: typeof WithdrawBiddingBlockBidGroupsResponseSchema;
  },
  /**
   * ブロック入札 CSV のチェック (= 構文 + 業務検証 + 差分プレビュー、 副作用なし)。
   *
   * @generated from rpc bffuser.v1.BiddingBlockService.CheckBiddingBlockCsv
   */
  checkBiddingBlockCsv: {
    methodKind: "unary";
    input: typeof CheckBiddingBlockCsvRequestSchema;
    output: typeof CheckBiddingBlockCsvResponseSchema;
  },
  /**
   * ブロック入札 CSV の確定 (= check_token を引き換えて承認依頼を作成)。
   *
   * @generated from rpc bffuser.v1.BiddingBlockService.ApplyBiddingBlockCsv
   */
  applyBiddingBlockCsv: {
    methodKind: "unary";
    input: typeof ApplyBiddingBlockCsvRequestSchema;
    output: typeof ApplyBiddingBlockCsvResponseSchema;
  },
  /**
   * まとめて承認 (AC-BSP-118)。 件数の上限は無い。 1 トランザクションでまとめて承認し、 承認できなかった
   * 案件は理由を results に返す。 error 応答ならどの案件も承認していない (通信の失敗では結果不明なので
   * 一覧を読み直す。 internalapi の同名 RPC 参照)。
   *
   * @generated from rpc bffuser.v1.BiddingBlockService.ApproveBiddingBlockApprovalRequests
   */
  approveBiddingBlockApprovalRequests: {
    methodKind: "unary";
    input: typeof ApproveBiddingBlockApprovalRequestsRequestSchema;
    output: typeof ApproveBiddingBlockApprovalRequestsResponseSchema;
  },
  /**
   * @generated from rpc bffuser.v1.BiddingBlockService.CheckBiddingBlockSubmissionDuplicates
   */
  checkBiddingBlockSubmissionDuplicates: {
    methodKind: "unary";
    input: typeof CheckBiddingBlockSubmissionDuplicatesRequestSchema;
    output: typeof CheckBiddingBlockSubmissionDuplicatesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_bidding_block_service, 0);

